import { useState, useCallback } from 'react';

export const useEpochsMinimap = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredEpoch, setHoveredEpoch] = useState<string | null>(null);
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [lastTouchY, setLastTouchY] = useState<number | null>(null);

  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    setTouchStart(e.touches[0].clientY);
    setLastTouchY(e.touches[0].clientY);
  }, []);

  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    if (!touchStart || !lastTouchY) return;

    const touchY = e.touches[0].clientY;
    const currentDiff = lastTouchY - touchY;
    
    const container = e.currentTarget;
    const isScrollable = container.scrollHeight > container.clientHeight;
    const isAtTop = container.scrollTop === 0;
    const isAtBottom = Math.abs(
      container.scrollHeight - container.clientHeight - container.scrollTop
    ) < 1;

    // Разрешаем нативный скролл внутри контента
    if (isScrollable && 
        ((currentDiff > 0 && !isAtBottom) || (currentDiff < 0 && !isAtTop))) {
      e.stopPropagation();
    }

    setLastTouchY(touchY);
  }, [touchStart, lastTouchY]);

  const handleTouchEnd = useCallback(() => {
    setTouchStart(null);
    setLastTouchY(null);
  }, []);

  return {
    isHovered,
    setIsHovered,
    hoveredEpoch,
    setHoveredEpoch,
    touchStart,
    setTouchStart,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd
  };
}; 